import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage } from '../../components';

function ImageTextList({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const bullets = data.bullets || [];
  const updateBullet = (i, t) => {
    const next = [...bullets];
    next[i] = t;
    update({ bullets: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-32 h-32 rounded-3xl bg-accent/20" />
            <EditableImage
              src={data.image?.src}
              alt={data.image?.alt || ''}
              onChange={(src, alt) => update({ image: { src, alt } })}
              className="relative rounded-3xl shadow-soft h-[480px] w-full object-cover"
            />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          <p className="section-lead">
            <EditableText value={data.lead} onChange={(t) => update({ lead: t })} as="span" multiline />
          </p>
          <ul className="mt-8 space-y-3">
            {bullets.map((p, i) => (
              <li key={i} className="flex gap-3 text-ink/80">
                <CheckCircle2 size={20} className="text-olive shrink-0 mt-0.5" />
                <EditableText value={p} onChange={(t) => updateBullet(i, t)} as="span" />
              </li>
            ))}
          </ul>
          {data.callout && (
            <div className="mt-8 p-5 rounded-2xl bg-olive-light border-l-4 border-accent">
              <EditableText value={data.callout} onChange={(t) => update({ callout: t })} as="strong" className="text-olive-deep" />
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}

export default ImageTextList;
